import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import { getRegulamentoList, postRegulamento, getRegulamentoAtivo } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import RegulamentoCard from '../../components/RegulamentoCard';
import { FormGroup } from '@material-ui/core';
import ButtonEscolherArquivo from '../../components/ButtonEscolherArquivo';
import { useGetUser } from '../../hooks/useGetUser';
import { useDispatch } from "react-redux";
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction
} from '../../store/actions/snackbarActions.js';

const dataInit = {
    regulamentoId: null,
    titulo: "",
    conteudo: "",
    linkPdf: "",
    ativo: true,
    roles: []
}

const Regulamento = () => {

    const history = useHistory();
    const [regulamentos, setRegulamentos] = useState([])
    const [verMais, setVerMais] = useState(true)
    const [modalLoading, setModalLoading] = useState(false);
    const [filter, setFilter] = useState( {page : 1, pageSize: 10, query: "" } );
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));
    const [data, setData] = useState(dataInit);
    const [nomeArquivo, setNomeArquivo] = useState("");
    const [linkArquivo, setLinkArquivo] = useState("");
    
    const user = useGetUser();

    const getRegulamentos = async() => {
        setModalLoading(true)
        const data = await getRegulamentoList(filter);
        setModalLoading(false)
        setRegulamentos(data.data);
    } 
    useEffect(()=>{
        (regulamentos && regulamentos.items?.length > 0 && regulamentos.page === regulamentos.totalPages ) ? setVerMais(true) : setVerMais(false); 
        getRegulamentos();
        getAtivo();
    },[])

    const addPage = async () => {
        setModalLoading(true)
        const data = await getRegulamentoList(filter);
        setModalLoading(false)
        const f = filter;
        f.page += 1;
        setFilter(f);
        getRegulamentos([...regulamentos, ...data.data])
    }

    const getAtivo = async () => {
        const reg = await getRegulamentoAtivo();
        setLinkArquivo(reg.data.linkPdf);
        setData(reg.data);
    }

    const enviar = async() => {
        setModalLoading(true)
        try{
            let formdata = data;
            formdata.regulamentoId = null;
            let info = await postRegulamento(formdata);
            showMsgS("Dados salvos com sucesso!")
            setTimeout(()=>{
                window.document.location.reload();
            }, 2000)
        } catch(e) {
            showMsgE("Ocorreu um erro ao salvar os dados")
        }
        setModalLoading(false)
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Regulamento
            </div>
            <div className={styles.subTitle}>
                Regulamento atual
            </div>

            { linkArquivo &&
                <embed src={linkArquivo} width="100%"></embed>
            }
            { (user.perfilAcesso === 'Master' ) && ( 
                <>
                    <div className={styles.buttonWrapper}>
                        <ButtonEscolherArquivo
                            changeImage={(file, nome)=>{setData({...data, 'linkPdf':file, 'titulo':nome}); setNomeArquivo(nome);}}
                            nomeArquivo={nomeArquivo}
                            modalLoading={setModalLoading}
                            />
                        <button className={styles.salvar} onClick={enviar}>
                            Processar arquivo
                        </button>
                    </div>

                    <div className={styles.subTitle}>
                        Log de importação
                    </div>
                    <div className={styles.acoesWrapper}>
                        {regulamentos && regulamentos.items?.map(
                            (r) => <RegulamentoCard regulamento={r}/>
                        )}
                    </div>
                    { verMais && (
                        <div className={styles.verMaisWrapper}>
                            <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                                Ver mais
                            </button>
                        </div>
                    )}
                </>
            )}
            <ModalLoading
                open={modalLoading} 
                size="lg"
            />
        </div>
    );
  
}

export default Regulamento;